// extracted by mini-css-extract-plugin
export default {"wrap":"vacations-application_wrap__r3aDj","vacations__panel":"vacations-application_vacations__panel__Qfkq5"};